<template src="./availabilitySummary.template.html"></template>
<script>
    import moment from "moment-timezone";
    export default {
        name: "availabilitySummary",
        props: ["searchObj", "parentCallback"],
        data() {
            return {
                apiUrl: window.location.protocol + '//' + window.location.hostname + (window.location.port ? ":1339" : ''),
                Reservationid: -1,
                confirmationid: -1,
                isAvailable: true,
                showFolio: true,
                variable: false,
                dateObj: {
                    startDate: moment.utc().format("YYYY-MM-DD"),
                    endDate: moment.utc().format("YYYY-MM-DD"),
                },
                BestAvailableRate: {},
                items: [],
                searchflag: null,
                Totalcount: null,
                loading: false,
                availableRoomsList: [],
                isShow: true,
                guestList: [
                ],
                value: 50,
                locationsList: [],
                selectedUnit: [],
                demo3: {
                    value: [0, 100],
                    width: '15%',
                    height: 8,
                    dotSize: 16,
                    min: 0,
                    max: 2000,
                    disabled: false,
                    show: true,
                    useKeyboard: true,
                    tooltip: 'always',
                    formatter: '${value}',
                    enableCross: false,
                    mergeFormatter: '${value1} ~ ${value2}',
                    bgStyle: {
                        backgroundColor: '#fff',
                        boxShadow: 'inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)'
                    },
                    tooltipStyle: {
                        backgroundColor: '#666',
                        borderColor: '#666'
                    },
                    processStyle: {
                        backgroundColor: '#999'
                    }
                },
                folioItemCharges: [],
                folioCharges: {},
                Best_Available_Rate: {},
                //showPriceInfo: false,
                //showPriceText: "Details"
            }
        },
        methods: {
            bookNow(inst) {
                let vm = this;
                if (window.innerWidth < window.innerHeight) {
                    // document.getElementById("custom-nav-bar").style.display = "";
                    // document.getElementById("page-content").style.padding = "0px";
                }
                console.log("inst===>", inst);
                this.$store.dispatch("guestInformation", {
                    data: {
                        selectedunit: inst,
                    }
                })
                let text = 'Reserve event in shopping cart.' + inst.NickName
                if(vm.$gtag && vm.$gtag.event){
                    vm.$gtag.event('Reserve event in shopping cart', {
                        'event_category': 'Book Now',
                        'event_label': 'Book Now',
                    })
                }
                vm.$router.push("/guestInfo/" + -1);
            },
            formatMoney(amount) {
                return this.$store.state.getFormattedAmount("$", amount);
            },
            formatDate(date) {
                return moment(date, "YYYY-MM-DD").format("DD MMM ");
            },
            formatStartDate(date) {
                let vm = this;
                let startYear = moment(vm.$store.state.filterObj.startDate, "YYYY-MM-DD").format("YYYY");
                let endYear = moment(vm.$store.state.filterObj.endDate, "YYYY-MM-DD").format("YYYY");
                if (startYear == endYear) {
                    return moment(date, "YYYY-MM-DD").format("DD MMM ");
                }
                else {
                    return moment(date, "YYYY-MM-DD").format("DD MMM YYYY");
                }
            },
            // showPriceDetails() {
            //     this.showPriceInfo = !this.showPriceInfo;
            //     if (this.showPriceInfo) {
            //         this.showPriceText = "Close"
            //     } else {
            //         this.showPriceText = "Details"
            //     }
            // },
            updateValues(values) {
                let scope = this;
                console.log("here", values);
                scope.$store.state.filterObj.startDate = moment(values.startDate).format("YYYY-MM-DDTHH:mm:ss");
                scope.$store.state.filterObj.endDate = moment(values.endDate).format("YYYY-MM-DDTHH:mm:ss");
                // scope.$emit("getavailability");
                scope.$store.state.bus.$emit("startAndEndTexts", { startDate: scope.$store.state.filterObj.startDate, endDate: scope.$store.state.filterObj.endDate });
            },
            formatEndDate(date) {
                let vm = this;
                let startYear = moment(vm.$store.state.filterObj.startDate, "YYYY-MM-DD").format("YYYY");
                let endYear = moment(vm.$store.state.filterObj.endDate, "YYYY-MM-DD").format("YYYY");
                return moment(date, "YYYY-MM-DD").format("DD MMM YYYY");
            },
            GetFolioLedgerTransDetails_beforesave() {
                let vm = this;
                vm.filterObj.Persons = vm.$store.state.filterObj.Persons == -99 || vm.$store.state.filterObj.Persons == '' ? null : vm.$store.state.filterObj.Persons;
                vm.filterObj.Adults = vm.$store.state.filterObj.Adults == -99 || vm.$store.state.filterObj.Adults == '' ? null : vm.$store.state.filterObj.Adults;
                vm.filterObj.Children = vm.$store.state.filterObj.Children == -99 || vm.$store.state.filterObj.Children == '' ? null : vm.$store.state.filterObj.Children;
                let obj = {
                    FolioId: null,
                    ReservationId: null,
                    UnitId: vm.selectedUnit.UnitId,
                    PropertyId: vm.selectedUnit.PropertyId,
                    StartDate: vm.$store.state.filterObj.startDate,
                    EndDate: vm.$store.state.filterObj.endDate,
                    NumOfAdults: vm.filterObj.Adults,
                    NumOfChildren: vm.filterObj.Children,
                    Persons: vm.filterObj.Persons,
                    RatePlanId: vm.$store.state.filterObj.RatePlanId
                };
                vm.folioItemCharges = [];
                vm.folioCharges = {};
                console.log("obj", obj)
                let sucessCallback = function (response) {
                    console.log("response in GetFolioLedgerTransDetails", response);
                    if (response && response.data) {
                        if (response.data[0]) {
                            vm.folioItemCharges = response.data[0]
                        }
                        if (response.data[2]) {
                            vm.folioCharges = response.data[2][0];
                        }
                        if (response.data[3]) {
                            vm.BestAvailableRate = response.data[3][0];
                        }
                    }
                },
                    failureCallback = function (error) {
                        console.log(error);
                    };
                vm.$store.state.sendApiRequest("beApi/GetFolioLedgerTransDetails", "post", obj, sucessCallback, failureCallback);
            },
            showReservationSummaryPanel(inst) {
                let vm = this;
                console.log("inst", inst);
                vm.selectedUnit = inst;
                vm.$store.state.filterObj.unitId = inst.UnitId;
                // vm.dateObj.startDate = moment.utc().format("YYYY-MM-DD");
                // vm.dateObj.endDate = moment.utc().format("YYYY-MM-DD");
                $(".reservationSummary").removeClass("animated fadeOutRight");
                $(".reservationSummary").addClass("expand animated fadeInRight");
                $(".menuMaskRevSum").show();
                // $(".reservationSummary").removeClass("menuMaskRevSum");
                vm.getAvailableRooms();
            },
            closeSummaryPannel() {
                let vm = this;
                $(".menuMaskRevSum").hide();
                $(".reservationSummary").removeClass("expand animated fadeInRight");
                $(".reservationSummary").addClass("animated fadeOutRight");
            },
            closeShoppingCart() {
                let vm = this;
                    vm.$store.state.filterObj.startDate = null,
                    vm.$store.state.filterObj.endDate = null,
                    // vm.$store.state.filterObj.Persons = null,
                    // vm.$store.state.filterObj.Adults = null,
                    // vm.$store.state.filterObj.Children = null,
                    // vm.$store.state.filterObj.Location = null,
                    vm.$store.state.filterObj.RatePlanId = null,
                    vm.$store.state.filterObj.Promocode = null,
                    // vm.$store.state.filterObj.FilteredAmenities = [],
                    // vm.$store.state.filterObj.Beds = 0,
                    // vm.$store.state.filterObj.Bathrooms = 0,
                    // vm.$store.state.filterObj.Beds = 0,
                    // vm.$store.state.filterObj.Bedrooms = 0,
                    // vm.$store.state.filterObj.value = [null, null],
                    // vm.getAvailableRooms();
                    $(".menuMaskRevSum").hide();
                $(".reservationSummary").removeClass("expand");
                vm.$store.state.bus.$emit("shoppingCart");
                vm.$store.state.bus.$emit("clearSearch", true);
            },
            closeSumPanel() {
                $(".menuMaskRevSum").hide();
                $(".reservationSummary").removeClass("expand");
                window.localStorage.setItem("component", "search");
            },
            imageURLS(imgGuid) {
                let isBase64 = /^data:image\/([a-zA-Z]*);base64,([^\"]*)/.test(imgGuid)
                if (isBase64) {
                    return imgGuid;
                }
                return this.apiUrl + '/downloadImage/' + imgGuid + '/430x300';
            },
            getAvailability() {
                let vm = this;
                if (vm.parentCallback) {
                    // vm.parentCallback();
                }
                // vm.getAvailableRooms();
            },
            getAvailableRooms() {
                let vm = this;
                vm.$store.state.filterObj.unitId = vm.searchObj.UnitId;
                vm.$store.state.filterObj.RatePlanId = vm.searchObj.RatePlanId;
                let sucessCallback = function (response) {
                    console.log("response in GetAvailability_BE", response);
                    if (response && response.data) {
                        if (response.data.roomDetailsListObjs) {
                            if (vm.$store.state.filterObj.unitId == null) {
                                vm.availableRoomsList = response.data.roomDetailsListObjs;
                            }
                            else if (vm.$store.state.filterObj.unitId != null && response.data.roomDetailsListObjs.length && response.data.roomDetailsListObjs.length == 1 && vm.$store.state.filterObj.unitId == response.data.roomDetailsListObjs[0].UnitId && vm.$store.state.filterObj && vm.$store.state.filterObj.startDate && vm.$store.state.filterObj.endDate) {
                                vm.isAvailable = true;
                                vm.showFolio = true;
                                console.log("response.data[1].length", response.data.roomDetailsListObjs.length)
                                vm.GetFolioLedgerTransDetails_beforesave();
                            }
                            else {
                                // vm.isAvailable = false;
                                // vm.showFolio = false;
                                vm.folioItemCharges = [];
                                vm.folioCharges = {};
                            }
                        }
                        console.log("")
                        if (vm.parentCallback) {
                            // vm.parentCallback();
                        }
                    }
                },
                    failureCallback = function (error) {
                        console.log(error);
                    };
                vm.$store.state.sendApiRequest("beApi/GetAvailability_BE", "post", vm.$store.state.filterObj, sucessCallback, failureCallback);
            },
        },
        computed: {
            filterObj() {
                let vm = this;
                console.log("this.$store.getters.getAvailableUnitsList", this.$store.getters.getFilteredData)
                return this.$store.getters.getFilteredData;
            },
            isVaildSubDomain() {
                let vm = this;
                return vm.$store.state.isValidDomainOrNot;
            }
        },
        mounted() {
            let vm = this;
            // vm.$gtag.event({
            //         eventCategory: 'ShoppingCart',
            //         eventAction: 'Display'
            // })
            // vm.isAvailable = true;
            // vm.showFolio = false;
            // if (vm.$store.state.filterObj && vm.$store.state.filterObj.startDate && vm.$store.state.filterObj.endDate) {
            //     vm.dateObj.startDate = vm.$store.state.filterObj.startDate;
            //     vm.dateObj.endDate = vm.$store.state.filterObj.endDate;
            // }
        },
        watch: {
            searchObj() {
                // handler: function (unitObj, oldVal) {s
                //     console.log("searchObj", unitObj);
                // console.log(" issame => ", JSON.stringify(this.selectedUnit) === JSON.stringify(unitObj))
                if (this.searchObj && this.searchObj.UnitId) {
                    let vm = this;
                    if (vm.$store.state.filterObj && vm.$store.state.filterObj.startDate && vm.$store.state.filterObj.endDate) {
                        // console.log("here in setDate")
                        vm.dateObj.startDate = vm.$store.state.filterObj.startDate;
                        vm.dateObj.endDate = vm.$store.state.filterObj.endDate;
                    }
                    // this.isAvailable = true;
                    // this.showFolio = false;
                    this.showReservationSummaryPanel(this.searchObj);
                }
                console.log("searchobj changed")
                // },
                // deep: true
            }
        },
        created() {
            let vm = this;
            vm.$store.state.bus.$on("startAndEndTexts", function (selected) {
                console.log("here it is");
                vm.dateObj.startDate = selected.startDate;
                vm.dateObj.endDate = selected.endDate;
            });
        },
        destroyed() {
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/availabilitySearch/availabilitySummary/availabilitySummary.vue